import { Injectable } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import * as sharedSelectors from '../shared/reducers/shared.reducer';
import * as firebase from 'firebase';
import { Utilities } from './utilities';

@Injectable()
export class HistoryData {

  private ip: string = 'NA';
  private client: any;

  constructor(
    private afs: AngularFirestore,
    private http: HttpClient,
    private store: Store<{}>,
    private utilities: Utilities
  ) {
    this.store.select(sharedSelectors.getIp).subscribe((ip: any) => {
      this.ip = ip;
    });

    this.store.select(sharedSelectors.getClient).subscribe((client: any) => {
      this.client = client;
    });
  }

  public set(title: string, moduleName: string, action: string, object: any) {
    const obj = {
      ip: this.ip,
      title: title,
      action: action,
      timestamp: firebase.firestore.FieldValue.serverTimestamp(),
      user: this.client.user,
      obj: object
    };

    return this.afs.collection(this.client.id).doc('history').collection(moduleName).add(obj);
  }

  /**
   * Set history client data
   *
   * @param title
   * @param moduleName
   * @param action
   * @param object
   */
  public setClient(title: string, moduleName: string, action: string, object: any) {
    const obj = {
      ip: this.ip,
      title: title,
      action: action,
      timestamp: firebase.firestore.FieldValue.serverTimestamp(),
      user: this.client.user,
      obj: object
    };

    return this.afs.collection(object.id).doc('history').collection(moduleName).add(obj);
  }

  public get(collection: string) {
    // TODO: Max 300 results
    return this.afs
              .collection(this.client.id)
              .doc('history')
              .collection(collection, ref => ref.orderBy('timestamp', 'desc').limit(300))
              .valueChanges();
  }

  public getMyIp() {
    return this.http.get('https://jsonip.com/')
  }
}
 // end file



// WEBPACK FOOTER //
// ./src/providers/history.ts